import { useI18n } from '@/lib/i18n';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

const About = () => {
  const { t, lang } = useI18n();

  const { data: settings } = useQuery({
    queryKey: ['site-settings'],
    queryFn: async () => {
      const { data } = await supabase.from('site_settings').select('*');
      const map: Record<string, string> = {};
      (data || []).forEach(s => { map[s.key] = s.value; });
      return map;
    },
  });

  const artistName = lang === 'ar' ? settings?.artist_name_ar || settings?.artist_name : settings?.artist_name || 'Melody';
  const artistBio = lang === 'ar' ? settings?.artist_bio_ar || settings?.artist_bio : settings?.artist_bio || t('aboutStory');
  const artistImage = settings?.artist_image;

  return (
    <div className="min-h-screen pt-16">
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center glass-panel p-8 md:p-12 rounded-3xl border-0">
            <img src="/logo.png" alt="Melody Art Gallery" className="h-24 md:h-32 w-auto mx-auto mb-8" />
            
            {artistImage && (
              <div className="w-40 h-40 md:w-52 md:h-52 rounded-full overflow-hidden mx-auto mb-8 border-4 border-primary/20 shadow-glow">
                <img src={artistImage} alt={artistName} className="w-full h-full object-cover" />
              </div>
            )}

            <h1 className="font-display text-2xl md:text-4xl font-bold text-foreground mb-4">{artistName}</h1>
            
            <p className="text-muted-foreground leading-relaxed text-sm md:text-base max-w-xl mx-auto whitespace-pre-line">
              {artistBio}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
